export default __webpack_public_path__ + "static/mobile-availabilities-e370be9c61e6863977b188f4b2f77bb5.png";